// Diagnostic logging for voice mode. Filter the console on `[voice]`.
// Never pass the user's words, Mor's message text, or tokens in here: counts, ids, turn
// numbers, flags and reasons only.

type Detail = Record<string, string | number | boolean | null | undefined>;

export function voiceLog(event: string, detail?: Detail): void {
  if (detail === undefined) {
    console.debug(`[voice] ${event}`);
  } else {
    console.debug(`[voice] ${event}`, detail);
  }
}

export function wordCount(text: string): number {
  const trimmed = text.trim();
  return trimmed === '' ? 0 : trimmed.split(/\s+/u).length;
}
